/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const tallCabinet36Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('TallCabinet36').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/higgins.glb',
            objectName: 'T3684',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=tall-cabinet-36.js.map